module.exports = __webpack_public_path__ + "small_purple_icons_fullwidthwp8bb773bcc71a08672a6ea12bb8004fd1.png";